module.exports = __webpack_public_path__ + "static/media/VE.89aac662.svg";